<template>
  <ComponentLayout id="add-to-stop-list">
    <template #breadcrumbs>
      <Breadcrumbs
        class="pa-0  "
        :items="breadcrumbs"/>
    </template>
    <template #main_content>
      <div
        class="mt-3 mb-5 text-left">
        <span class=" h1-headline">{{ $t('StopLists.ProvideInformationAboutSupplier') }}</span>
      </div>
      <div class="width-100 px-10 radius-8 add-to-stop-list-card flex text-left pt-6">
        <sForm
          ref="addToStopList"
          :disabled="loading"
          label-position="top"
          :model="toLock"
          :rules="rules">
          <div>
            <div class="add-to-stop-list__title h4-headline pb-3">
              {{ $t('StopLists.SupplierInformation') }}
            </div>
            <div class="mb-5">
              <sFormItem
                ref="selectedOrg"
                prop="company">
                <template v-slot:label>
                  <span class=" h8-text px-0">
                    {{ bigFirstLetter($t('Tenders.Company')) }}
                  </span>
                </template>
                <sSelect
                  allow-create
                  autocomplete
                  class="add-to-stop-list__select-org width-90"
                  clearable
                  data-qa="add-to-stop-list__select-org"
                  :disabled="!!loading || !!lock_usreou"
                  filterable
                  :loading="loading"
                  :placeholder="bigFirstLetter($t('Tenders.Company'))"
                  remote
                  :remote-method="checkUsreou"
                  :value.sync="toLock.company"
                  value-key="organizationId">
                  <sOption
                    v-for="item in filtred_orgs_list"
                    :key="`organisation-${item.usreou}-${item.name}-${item.organizationId}`"
                    :data-qa="`organisation-${item.usreou}-${item.name}-${item.organizationId}`"
                    :label="item.name"
                    :value="item"/>
                </sSelect>
              </sFormItem>
              <sFormItem
                v-if="is_main_org"
                ref="selectedChildOrg"
                prop="organizationIdsForBlock">
                <template v-slot:label>
                  <span class=" h8-text px-0">
                    {{ $t('StopLists.BlockFor') }}
                  </span>
                </template>
                <!-- todo filterable зараз баг  multiple + filterable -->
                <sSelect
                  class="add-to-stop-list__select-child-org width-90 "
                  clearable
                  data-qa="add-to-stop-list__select-child-org"
                  :disabled="!!loading"
                  filterable
                  :loading="loading"
                  multiple
                  :placeholder="bigFirstLetter($t('Tenders.Company'))"
                  :value.sync="toLock.organizationIdsForBlock"
                  value-key="organizationId">
                  <sOption
                    v-for="item in childListOrganizators"
                    :key="`organisation-${item.usreou}`"
                    :data-qa="`organisation-${item.usreou}`"
                    :label="item.name"
                    :value="item"/>
                </sSelect>
              </sFormItem>
              <sFormItem
                class="flex flex-wrap flex-direction-column mt-5"
                prop="term">
                <template v-slot:label>
                  <span class=" h5-headline px-0">
                    {{ $t('StopLists.BlockingTerms') }}
                  </span>
                </template>
                <sRadioGroup
                  v-model="toLock.term"
                  class="add-to-stop-list__lock-terms mt-4 ml-4"
                  data-qa="add-to-stop-list__lock-terms">
                  <sFormItem
                    ref="periodFormItem"
                    prop="period">
                    <sRadio
                      data-qa="add-to-stop-list__lock-priod"
                      label="period">
                      <div
                        class="add-to-stop-list__lock-priod d-flex">
                        <DateRangeDialog
                          :options="{from: { disabled: true, default: $moment().format('YYYY-MM-DD') }}"
                          :search.sync="toLock.period"
                          :show-periods="false"
                          @apply="changePeriod">
                          <template v-slot:activator="{ on, open }">
                            <div
                              class="custom-masked-input date-chip no-gutters pl-3 pr-2 "
                              style="justify-content: space-between;">
                              <div>
                                <span class="grey--text">{{ $t('Common.DateFrom') }}</span>
                                <span
                                  class="pl-2"
                                  data-qa="date_from">{{ date_from_format }}</span>
                              </div>
                              <sIcon
                                size="14"
                                type="calendar"/>
                            </div>
                            <div
                              class="ml-5 custom-masked-input date-chip no-gutters pl-3 pr-2"
                              style="justify-content: space-between;"
                              v-on="on"
                              @click="open">
                              <div>
                                <span class="grey--text">{{ $t('Common.DateTo') }}</span>
                                <span
                                  class="pl-2"
                                  data-qa="date_to">{{ date_to_format }}</span>
                              </div>
                              <sIcon
                                size="14"
                                type="calendar"/>
                            </div>
                          </template>
                        </DateRangeDialog>
                      </div>
                    </sRadio>
                  </sFormItem>
                  <sRadio
                    data-qa="add-to-stop-list__lock-permanently"
                    label="permanently">
                    {{ $t('StopLists.Permanently') }}
                  </sRadio>
                </sRadioGroup>
              </sFormItem>
              <sFormItem
                class="flex flex-direction-column mt-4 mb-0"
                prop="reason">
                <template v-slot:label>
                  <span class=" h5-headline pb-1 px-0">
                    {{ $t('StopLists.BlockingReason') }}
                  </span>
                </template>
                <sInput
                  clearable
                  data-qa="add-to-stop-list__reason"
                  :max-length="4000"
                  max-rows="20"
                  rows="6"
                  type="textarea"
                  :value.sync="toLock.reason"/>
              </sFormItem>
              <ImportBlock
                class="pt-5"
                :create-file-handler="createFileHandler"
                data-qa="files"
                :disabled="!!loading"
                :files.sync="files"
                files-types
                inline-style="width: 100%"/>
            </div>
          </div>
        </sForm>
        <sAlert
          class="pt-4"
          min-height>
          {{ $t('StopLists.CompanyNotParticipatedInBidding') }}
        </sAlert>
      </div>
    </template>
    <template #footer>
      <ComponentFooter
        key="footer"
        :back="close"
        :back_btn="$t('Common.Cancel')"
        :next_btn="false">
        <template v-slot:next>
          <StoppedDialog
            :add="submit"
            :loading.sync="loading"
            :participant="toLock.company"
            :validate="validateForm"/>
        </template>
      </ComponentFooter>
    </template>
  </ComponentLayout>
</template>

<script>
import Breadcrumbs from 'components/common/elements/Breadcrumbs.vue'
import ComponentLayout from 'pages/templates/ComponentLayout.vue'
import ComponentFooter from 'components/common/blocks/ComponentFooter.vue'

import ImportBlock from 'components/common/blocks/ImportBlock.vue'
import StoppedDialog from 'components/stop lists/StoppedDialog.vue'
import DateRangeDialog from 'components/common/dialogs/DateRangeDialog.vue'

import { debounce } from 'toolkit/utils/util'
import moment from 'moment'
import { modalMixin, stopListsMixin, validateRuls } from 'mixins'
import { mapGetters } from 'vuex'
import { StopListFile } from '@/types/commonFile.js'

export default {
  name: 'addToStopList',
  mixins: [ modalMixin, stopListsMixin, validateRuls ],
  data() {
    const that = this
    return {
      loading: false,
      filtred_orgs_list: [],
      all_filtred_orgs_list: [],
      files: [],
      childListOrganizators: [],
      is_main_org: false,
      load_children: false,
      is_locked: false,
      toLock: {
        reason: '',
        period: [],
        company: undefined,
        term: null,
        organizationIdsForBlock: []
      },
      rules: {
        company: {
          required: true,
          trigger: 'change',
          validator: (rule, value, callback) => {
            if (! value ) {
              callback(that.$t('Validate.Required'))
            }
            callback()
          },
        },
        period: {
          required: true,
          trigger: 'change',
          validator: (rule, value, callback) => {
            if ( that.toLock.term == 'period' && ( !value?.length || value?.some( el => !el) ) ) {
              callback(that.$t('Validate.Required'))
            }
            callback()
          },
        },
        reason: [
          {
            type: 'string',
            trigger: 'change',
            max: 4000,
            message: this.$t('Validate.maxLength', {number: 4000, type: this.$tc('Common.characters', 4000) })
          },
          {
            required: true,
            trigger: 'change',
            validator: (rule, value, callback) => {
              if (!value ) {
                callback(new Error(that.$t('Validate.Required')))
              }
              callback()
            },
          }
        ],
        term: {
          required: true,
          trigger: 'change',
          validator: (rule, value, callback) => {
            if (!value ) {
              callback(that.$t('Validate.Required'))
            }
            callback()
          },
        },
      },
    }
  },
  filters: {
    formatDate(value) {
      if (value && moment(value).isValid()) {
        return moment(value).format('DD/MM/YYYY')
      } else {
        return ''
      }
    },
  },
  created() {
    if (this.$acl.get.includes('tenders_view')) {
      this.$router.push({name: 'page-error', params: { status_code: '403', descript: 'Нет доступа к add to stop list' } })
    }
    this.loading = true
    this.rules.reason.push(this.commentValidateRule[0])
    this.$store.dispatch('getOrganizationsList')
      .then( async res => {
        let list = await this.$store.dispatch('getStopList')
        this.filtred_orgs_list = res.filter(org => {
          return !list.some(item => item.stopListMembers.find( memb => {
            let org_id = this.$route?.query?.id,
              in_link = this.lock_usreou && org.usreou.trim() == this.lock_usreou && org_id && org.organizationId == org_id,
              is_locked = memb?.usreou.trim() == org.usreou.trim() && memb.organizationId == org.organizationId && memb.totalStopListBlockRow?.status == 'E'

            if (in_link) {
              if (is_locked) {
                this.is_locked = true
                this.$notice.warning({
                  title: this.$t('Common.ErrorTitle'),
                  message: this.$t('StopLists.AlreadyAddedStopList', {participant: memb.organizationName})
                })

                this.close()
                return is_locked
              }
              this.toLock.company =  org || this.lock_usreou
            }
            return is_locked
          })
          )
        })
        this.toLock.company ||= this.lock_usreou
        this.all_filtred_orgs_list = this.$_.cloneDeep(this.filtred_orgs_list)
        this.checkUsreou(this.lock_usreou, true)
      })
      .finally(() => this.loading = false)

    this.load_children = true
    this.$store.dispatch('childListOrganizators')
      .then( res => {
        if ( res ) {
          this.childListOrganizators = res
          if ( res?.length > 1) {
            this.is_main_org = true
          }
          let currrent = this.childListOrganizators.find(el => el.usreou == this.currentOrganization.oKPO )
          this.toLock.organizationIdsForBlock = currrent ? [ currrent ] : []
        }
      })
      .finally(() => this.load_children = false)
  },
  beforeDestroy() {
    if ( !this.is_locked ) {
      this.$notice.closeAll()
    }
  },
  computed: {
    ...mapGetters({
      orgs_list: 'getOrganizationsList',
      currentOrganization: 'getCurrentOrganization',
    }),
    lock_usreou() {
      return this.$route?.query?.usreou
    },
    date_to_format: {
      get() {
        if (!this.toLock.period[1]) { return null }
        return moment(this.toLock.period[1]).format('DD.MM.YYYY')
      },
      set(val) {
        this.toLock.period[1] =  moment(val, 'DD/MM/YYYY').format('YYYY-MM-DD')
      }
    },
    date_from_format: {
      get() {
        if (!this.toLock.period[0]) { return null }
        return moment(this.toLock.period[0]).format('DD.MM.YYYY')
      },
      set(val) {
        this.toLock.period[0] = moment(val, 'DD/MM/YYYY').format('YYYY-MM-DD')
      }
    },
    breadcrumbs() {
      return [
        {
          text: this.$t('Menu.StopLists'),
          action: this.close
        },
        {
          text: this.bigFirstLetter(this.$t('StopLists.AddCompany')) ,
        },
      ]
    },
  },
  methods: {
    filterOrgs(item, queryText, itemText) {
      let search = queryText.toLocaleLowerCase()
      return itemText.toLocaleLowerCase().includes(search) || item.usreou.toLocaleLowerCase().includes(search)
    },
    changePropDate(date) {
      this.$refs.menu_date?.$refs.menu?.save(date)
    },
    createFileHandler(file) {
      return new StopListFile( file )
    },
    changePeriod(val) {
      this.toLock.term = 'period'
      this.$refs.periodFormItem.$emit.apply(this.$refs.periodFormItem, ['s.form.change'].concat(val))
    },
    validateForm() {
      this.loading = true
      return new Promise((resolve) => {
        this.$refs.addToStopList.validate((valid) => {
          this.loading = false
          return resolve(valid)
        })
      })
    },
    async submit() {
      this.loading = true
      //try {
      let model = {
        model: {
          organizationId: this.toLock.company.organizationId ,      // Int
          usreou: this.toLock.company.usreou || this.toLock.company ,      // String!
          lockReason: this.toLock.reason,      // String!
          dateStart: moment( this.toLock.period[0] ).format('YYYY-MM-DDTHH:mm:ss'),      // DateTime ???
          dateEnd: this.toLock.term == 'permanently' ? null : moment( this.toLock.period[1] ).format('YYYY-MM-DDTHH:mm:ss'),      // DateTime
          organizationIdsForBlock: this.toLock.organizationIdsForBlock.map(el => el.organizationId)
        },
        files: this.files.map(el  => el.file)
      }

      return await this.$store.dispatch('addToStopList', model )
        .then(async (result) => {
          if (result?.length) {
            this.$store.dispatch('getStopList', true)
            return result
          }
        })
        .catch(async (error) => {
          this.$notice.info({
            title: this.$t('Common.PleaseNote'),
            message: this.$t('Errors.' + error.graphQLErrors?.[0]?.extensions?.code || 'STHWrong'),
            showClose: true,
            progress: true,
            duration: 10
          })
          throw error
        })
        .finally(() => {
          this.loading = false
        })
      //}
      /* catch (error ) {
        this.$notice.error({
          title: this.$t('Common.ErrorTitle'),
          message: error?.message || error,
          duration: 10,
        })
        this.$log_error( error )
        throw error
      } finally {
        this.loading = false
      }*/

    },
    checkUsreou: debounce( function (val, set) {
      if (!val) {
        this.filtred_orgs_list = this.$_.cloneDeep(this.all_filtred_orgs_list)
        return
      }
      let search = val?.toLocaleLowerCase(),
        checkIncluding = (text) => text?.toLocaleLowerCase().includes(search),
        matches_usreou = val.match(/\d{8,10}/)

      this.filtred_orgs_list = this.orgs_list.slice(0).filter(item => checkIncluding(item.name) || checkIncluding(item.usreou) )
      if ( !this.filtred_orgs_list?.length && matches_usreou && matches_usreou[0]?.length == val.length) {
        this.$store.dispatch('getOrganizationInfo', matches_usreou[0]).then(res => {
          if ( !res ) { return }
          this.filtred_orgs_list = res
          if (res[0] && this.toLock.company == res[0]?.usreou ) {
            this.toLock.company = res[0]
          }

        })
      } else if (set && this.filtred_orgs_list?.length) {
        this.toLock.company = this.filtred_orgs_list[0]
      }
    }, 300)
  },
  components: {
    Breadcrumbs,
    ImportBlock,
    StoppedDialog,
    ComponentLayout,
    ComponentFooter,
    DateRangeDialog
  }
}
</script>
<style lang="scss" scoped>
.add-to-stop-list-card {
  box-shadow: none !important;
  background-color: var(--v-main__light_green-base);
}
</style>
<style lang="scss">
#component-layout-add-to-stop-list {
  .date-chip {
    &:first-child {
      border-color: var(--v-secondary__green_not_active-base);
      opacity: .5;
      cursor: not-allowed;
    }
    width: 172px;
    max-width: 172px;

  }
}
</style>
